<form nz-form style="padding-top:12px;padding-right:12px" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']" class="import">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Cơ sở</nz-form-label>
       
          <input nz-input [value]="schoolName" placeholder="Nhập cơ sở" [jAutofocus]> 
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Chọn file</nz-form-label>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton" >
          <input type="text" nz-input [value]="importStudent.tenFile" placeholder="Chọn file" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" nzSearch (click)="suffixFileClick()" id="button-file" matSuffix><i nz-icon nzType="paper-clip"></i></button>
        </ng-template>
        </nz-form-item>
        <!-- <button (click)="suffixFileClick()" id="button-file" matSuffix><i
            [style.color]="importStudent.tenFile != '' ? 'red' : ''"
            nz-icon nzType="paper-clip" nzTheme="twotone">{{importStudent.tenFile == '' ? 'Chọn file' : 'clear'}}</i></button> -->
      <input #file id="file-selector" type="file" style="display:none;" (change)="finishUpload($event.target.files)">
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Kết quả import</nz-form-label>
        
          <textarea nz-input [style.color]="discoloration == true ? 'green' : 'brown'" [value]="importStudent.ketQuaImport" ></textarea>
       
      </nz-form-item>
    </div> 
  </div>
  <div *nzModalFooter>
    <div class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>
      <button nz-button (click)="taiVe()" [disabled]="isDisabled">Tải về</button>&nbsp;
      <button nz-button nzType="primary" (click)="import()"  [nzLoading]="isImporting" type="submit">Import</button>
    </div>

  </div>
</form>